export default __webpack_public_path__ + "static/media/salon_logo_demo.b3678fcc.png";